// extracted by mini-css-extract-plugin
export default {"root":"TenantCard_root__0sUfM","header":"TenantCard_header__wcy6d","container":"TenantCard_container__kmpvA","contact":"TenantCard_contact__LghW5"};